import { render, staticRenderFns } from "./PublicWorksInfoQuestion.vue?vue&type=template&id=b8bc8c1c"
import script from "./PublicWorksInfoQuestion.vue?vue&type=script&lang=ts"
export * from "./PublicWorksInfoQuestion.vue?vue&type=script&lang=ts"
import style0 from "./PublicWorksInfoQuestion.vue?vue&type=style&index=0&id=b8bc8c1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports